var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("job-published-pasts", {
    attrs: {
      title: "過去のオプション情報プレビュー",
      "component-name": "job-published-option",
      "recent-past-objects": _vm.recentPastOptions,
      "past-objects": _vm.pastOptions,
    },
    scopedSlots: _vm._u([
      {
        key: "head",
        fn: function () {
          return [
            _c("tr", { attrs: { "data-test": "head" } }, [
              _c("th", { staticClass: "boss-table-head-center" }, [
                _vm._v("\n        フォーマット\n      "),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "boss-table-head-center" }, [
                _vm._v("\n        記事名\n      "),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "boss-table-head-center" }, [
                _vm._v("\n        掲載期間\n      "),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "boss-table-head-center" }, [
                _vm._v("\n        プレビュー\n      "),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }